import { CDN_CLRSAVE_URL } from './index';

export const ON_HOLD = {
  message:
    'We are sorry! Your previous/existing KYC is on hold. ClearTax does not accept KYC modification requests currently. You can get in touch with your bank to get your KYC modified.',
  button: true,
  buttonLabel: 'GO TO CLEARTAX HOME',
  buttonLink: '/',
};

export const KYC_STEPS = [
  {
    header: 'KYC form - Filled and attested',
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave/success-tick.png`,
    steps: [
      `Print the KYC form and affix a <b>passport photograph</b> of yours
      and <b>cross sign</b> across the photograph.`,
      `Also, ticket the relevant cehckbox in section 3 (POA) as per the
      <b>Address proof</b> that you are planning to send us along with
      the <b>id number</b> in the corresponding box.`,
    ],
  },
  {
    header: 'Attested copy of PAN + additional address proof',
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave/success-tick.png`,
    steps: [
      `Send scanned copy of <b>attested PAN card</b>`,
      `Send scanned copy of any one of the <b>attested address proof</b> ( Driving License, Aadhaar card)`,
    ],
  },
  {
    header: 'A selfie holding your PAN card',
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave/success-tick.png`,
    steps: [
      `Send us a picture of you <b>holding you PAN</b> as a high resolution image.`,
    ],
  },
  {
    header: 'A photograph of your signature',
    iconUrl: `${CDN_CLRSAVE_URL}/clearsave/success-tick.png`,
    steps: [
      `Send us a picture of you <b>your signature</b> as a high resolution image.`,
    ],
  },
];



// WEBPACK FOOTER //
// ./constants/kycStatus.ts